import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { Ref } from 'vue';
import type { DataLayerItem } from '~~/common/types/global';

type AnalyticsStoreId = 'AUCHAN_GTM_0';

export const useAwAnalyticsStore = defineStore('awAnalytics', () => {
  const AUCHAN_GTM_0 = ref<DataLayerItem[] | null>(null);
  const analyticsStoreRefereces: Record<AnalyticsStoreId, Ref<DataLayerItem[] | null>> = {
    AUCHAN_GTM_0,
  };

  function setAnalytics ({
    id,
    value,
  }: {
    id: AnalyticsStoreId;
    value: DataLayerItem[];
  }): void {
    analyticsStoreRefereces[id].value = JSON.parse(JSON.stringify(value));
  }

  function pushToAnalytics ({
    id,
    value,
  }: {
    id: AnalyticsStoreId;
    value: DataLayerItem;
  }): void {
    analyticsStoreRefereces[id].value!.push(JSON.parse(JSON.stringify(value)));
  }

  return {
    AUCHAN_GTM_0,
    setAnalytics,
    pushToAnalytics,
  };
});
